module.exports = __webpack_public_path__ + "img/rule-title.ccb9e030.png";